import classNames from 'classnames';
import React from 'react';
interface SearchInputProps {
  Search: string;
  setSearch: (Search: string) => void;
}
const SearchInput = ({Search, setSearch}: SearchInputProps) => {
  const buttonClassess = classNames('icon-close text-[12px] absolute left-4', {
    hidden: Search.length < 1,
  });
  const clearTextHandler = () => {
    setSearch('');
  };
  return (
    <div className="relative h-fit w-full flex items-center bg-gray-1 focus:outline-primary  rounded-xl  text-gray-5">
      <span className="absolute icon-Search   rounded-xl right-2 text-[18px]" />
      <input
        className="w-full px-5 pr-8 py-4 focus:outline-primary bg-inherit text-[16px] font-medium rounded-xl"
        value={Search}
        onChange={e => setSearch(e.target.value)}
        placeholder="جستجو محصول"
      />
      <button onClick={() => clearTextHandler()} className={buttonClassess} />
    </div>
  );
};

export default SearchInput;
